export const selectFilterValue = (state) => state.filter;
